import React from 'react';
import { Box, IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Delete, GetApp, Visibility } from '@mui/icons-material';

const FoodAnalysisActions = ({
  canDownload,
  canDelete,
  isDownloading,
  isDeleting,
  onViewDetails,
  onDownload,
  onDelete,
  viewDetailsColor = '#26786A',
  downloadColor = '#26786A',
  deleteColor = '#f44336',
}) => {
  return (
    <Box style={{ display: 'flex', gap: '4px' }}>
      {canDownload && (
        <>
          <Tooltip title="View Details">
            <IconButton size="small" onClick={onViewDetails} style={{ color: viewDetailsColor }}>
              <Visibility fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download Analysis Report">
            <IconButton size="small" onClick={onDownload} disabled={isDownloading} style={{ color: downloadColor }}>
              {isDownloading ? (
                <CircularProgress size={16} style={{ color: '#26786a' }} />
              ) : (
                <GetApp fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </>
      )}

      {canDelete && (
        <Tooltip title="Delete Analysis">
          <IconButton size="small" onClick={onDelete} disabled={isDeleting} style={{ color: deleteColor }}>
            {isDeleting ? <CircularProgress size={16} style={{ color: '#26786a' }} /> : <Delete fontSize="small" />}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default FoodAnalysisActions;
